export const APP_NAME = process.env.REACT_APP_NAME;
export const PLACE_HOLDER_IMAGE = process.env.REACT_APP_PLACEHOLDER_IMAGE;
export const API_URL = process.env.REACT_APP_API;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL as string;
export const AUTH_SAVE = process.env.REACT_APP_AUTH_SAVE_NAME;
export const MAP_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export const SECRET_KEY = process.env.REACT_APP_HASH_SECRET as string;
